/**
 * Scroll-triggered animations for Prince of Manifestation theme
 */

(function() {
  'use strict';

  // Intersection Observer for fade-in animations
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // Observe all fade-in elements
  document.addEventListener('DOMContentLoaded', function() {
    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach(el => fadeObserver.observe(el));
  });

  // Parallax scroll effect for hero cards - DISABLED
  // This effect was causing card-2 to glitch on hover by overwriting CSS transforms
  // with inline styles that have higher specificity than CSS hover rules.
  // The inline transform removed the translate(-50%, -50%) centering needed for card-2.
  //
  // window.addEventListener('scroll', function() {
  //   const scrollY = window.pageYOffset;
  //   const cards = document.querySelectorAll('.scroll-card');
  //
  //   cards.forEach((card, index) => {
  //     const speed = 0.5 + (index * 0.2);
  //     const yPos = -(scrollY * speed);
  //     card.style.transform = `translateY(${yPos}px)`;
  //   });
  // });

  // Smooth scroll to anchors
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      e.preventDefault();
      const target = document.querySelector(href);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Add sparkle effect on mouse move for key section
  const keySection = document.querySelector('.golden-key-section');
  if (keySection) {
    keySection.addEventListener('mousemove', function(e) {
      if (Math.random() > 0.95) {
        createTemporarySparkle(e.clientX, e.clientY);
      }
    });
  }

  function createTemporarySparkle(x, y) {
    const sparkle = document.createElement('div');
    sparkle.className = 'gold-particle';
    sparkle.style.left = x + 'px';
    sparkle.style.top = y + 'px';
    sparkle.style.position = 'fixed';
    sparkle.style.pointerEvents = 'none';
    sparkle.style.zIndex = '9999';

    document.body.appendChild(sparkle);

    setTimeout(() => {
      sparkle.remove();
    }, 3000);
  }

})();
